"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _csrf = require("@insided/shared/utils/csrf");

var _classnames = _interopRequireDefault(require("classnames"));

var _axios = _interopRequireDefault(require("axios"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'sso-flow';
exports.cssAnchorName = cssAnchorName;
var CONTAINER_SELECTOR = '.js-sso-flow';

var SsoFlow = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SsoFlow, _Component);

  var _super = _createSuper(SsoFlow);

  function SsoFlow() {
    var _this;

    (0, _classCallCheck2.default)(this, SsoFlow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: false,
      hasSucceeded: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
        var _document$querySelect;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                e.stopPropagation();

                if (!(_this.state.isLoading || _this.state.hasSucceeded)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _this.setState({
                  isLoading: true
                });

                SsoFlow.mutateContainer(false);
                _context.prev = 6;
                _context.next = 9;
                return _axios.default.post(_this.props.url, new URLSearchParams((0, _csrf.withCsrf)(_this.props.params)));

              case 9:
                _this.setState({
                  isLoading: false,
                  hasSucceeded: true
                });

                SsoFlow.mutateContainer(true);
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);

                // Keep box--alert on failure — only clear the loader.
                _this.setState({
                  isLoading: false
                });

                (_document$querySelect = document.querySelector(CONTAINER_SELECTOR)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.remove('is-loading');

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 13]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(SsoFlow, [{
    key: "render",
    value: function render() {
      var url = this.props.url;
      var _this$state = this.state,
          hasSucceeded = _this$state.hasSucceeded,
          isLoading = _this$state.isLoading;
      return (0, _preact.h)("span", null, (0, _preact.h)("span", {
        class: (0, _classnames.default)('js-sso-flow-mail--alert', {
          'is-hidden': hasSucceeded
        })
      }, (0, _preact.h)(_phrase.default, {
        p: "sso.mailnotification.check",
        renderAsText: true
      })), (0, _preact.h)("span", {
        class: (0, _classnames.default)('js-sso-flow-mail--send', {
          'is-hidden': !hasSucceeded
        })
      }, (0, _preact.h)(_phrase.default, {
        p: "sso.mailnotification.send",
        renderAsText: true
      })), !hasSucceeded && (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(url),
        class: (0, _classnames.default)({
          'is-loading': isLoading
        }),
        onClick: this.handleClick
      }, (0, _preact.h)(_phrase.default, {
        p: "sso.maillink.send",
        renderAsText: true
      })));
    }
  }]);
  return SsoFlow;
}(_preact.Component);

exports.default = SsoFlow;
(0, _defineProperty2.default)(SsoFlow, "mutateContainer", function (toSuccess) {
  var container = document.querySelector(CONTAINER_SELECTOR);
  if (!container) return;
  container.classList.remove('is-loading');

  if (toSuccess) {
    container.classList.remove('box--alert');
    container.classList.add('box--success');
  } else {
    container.classList.add('is-loading');
  }
});